module.exports = __webpack_public_path__ + "b7c7bc4def551a148b519f64961d3122.svg";